module.exports = __webpack_public_path__ + "media/images/sp/top/recommend-plan-text-wedding3-f993a13ea08079abd7f83d354a1ee2a2.png";